export default __webpack_public_path__ + "static/media/logoNew.2d56a3f6.png";